var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.instance_id)?_c('div',[_c('Create',{staticClass:"mt-3",attrs:{"instance-id":_vm.instance_id},on:{"created":_vm.update}}),_c('Table',{ref:"list",staticClass:"mt-4",attrs:{"instance-id":_vm.instance_id}}),_c('router-view')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }